<script setup>
import { useAuth } from '@clerk/vue'
import { watch } from 'vue'

import { ROUTE_PATHS } from '@/routes/route-helpers'

defineOptions({
  name: 'WebAppLogout'
})

const { signOut, isSignedIn, isLoaded } = useAuth()

watch(
  () => isLoaded.value,
  async loaded => {
    if (!loaded) return

    if (isSignedIn.value) {
      await signOut.value({
        redirectUrl: ROUTE_PATHS.WEB_APP_LOGIN
      })
    }
  },
  { immediate: true }
)
</script>

<script>
export default {
  render: () => null
}
</script>
